import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["href", "linkDisplayName", "linkType", "mode", "onModeChange", "onSave", "onImageRemove", "onAnchorPreviewClick", "onReplace", "onUnlink"];
import { PopoverBodyMode } from '../../constants/popover';
//@ts-expect-error untyped module
import withLinkState from '../links/withLinkState';
import ImagePopoverBodyLite from './ImagePopoverBodyLite';
//@ts-expect-error untyped module
import ImagePopoverBodyEdit from './ImagePopoverBodyEdit';
import { jsx as _jsx } from "react/jsx-runtime";
function ImagePopoverBodyBranch(props) {
  const {
      href,
      linkDisplayName,
      linkType,
      mode = PopoverBodyMode.PREVIEW,
      onModeChange,
      onSave,
      onImageRemove,
      onAnchorPreviewClick,
      onReplace,
      onUnlink
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (mode === PopoverBodyMode.PREVIEW) {
    const handleEdit = () => {
      onModeChange(PopoverBodyMode.EDIT);
    };
    return /*#__PURE__*/_jsx(ImagePopoverBodyLite, {
      href: href,
      linkDisplayName: linkDisplayName,
      linkType: linkType,
      onAnchorPreviewClick: onAnchorPreviewClick,
      onEdit: handleEdit,
      onReplace: onReplace,
      onUnlink: onUnlink,
      onRemove: onImageRemove
    });
  }
  const handleClose = () => {
    onModeChange(PopoverBodyMode.PREVIEW);
  };
  const handleSave = imageAttrs => {
    handleClose();
    onSave(imageAttrs);
  };
  return /*#__PURE__*/_jsx(ImagePopoverBodyEdit, Object.assign({}, rest, {
    href: href,
    linkDisplayName: linkDisplayName,
    linkType: linkType,
    onAnchorPreviewClick: onAnchorPreviewClick,
    onSave: handleSave,
    onClose: handleClose,
    onReplace: onReplace
  }));
}
ImagePopoverBodyBranch.displayName = 'ImagePopoverBodyBranch';
export default withLinkState(ImagePopoverBodyBranch);